import React from "react";

const Switch = ({ withBorder, right, left, label, note, disabled, setFieldValue, skip, name, style, onChange, handleChange, wrapperClassName, labelWidth, values }) => {

	return <div className={`switcher-container ${withBorder ? 'withBorder' : ''} ${right ? 'right' : ''} ${wrapperClassName}`} style={style}>
		{left && <label htmlFor={name} className="switcher-label">
			<div className="paylixecommerce-label" style={{ width: labelWidth, marginBottom: note ? '.3rem' : 0 }}>{label}</div>
			{note && <div className="paylixecommerce-note">{note}</div>}
		</label>}

		<label className={`switcher ${left ? 'left' : ''}`}>
			<input
				type="checkbox"
				id={name}
				name={name}
				disabled={disabled}
				checked={values[name]}
			   	onChange={(e) => {
					handleChange(`${name}`);
					if(onChange) {
						onChange(e.target.checked)
					}
				   if(!skip) {
					   setFieldValue(name, e.target.checked)
				   }
				}}
			/>
			<span className="switcher-slider" />
		</label>

		{!left && <label htmlFor={name} className="switcher-label">
			<div className="paylixecommerce-label" style={{ width: labelWidth, marginBottom: note ? '.3rem' : 0 }}>{label}</div>
			{note && <div className="paylixecommerce-note">{note}</div>}
		</label>}
	</div>
}

export default Switch;
